import { sitesPipelineStore } from "../store";
import { useSnapshot } from "valtio";
import { Stage } from "react-migration/domains/sites/typings/Stage";

export const useStageByStageId = (stageId: string) => {
  const { stageByStageId } = useSnapshot(sitesPipelineStore);

  return (stageByStageId[stageId] as Stage) ?? null;
};
